import { useMutation, useQueryClient } from "@tanstack/react-query"
import { appointment } from  '@shared/api/services'

export const useRemoveHomework = (appointmentId) => {
	const queryClient = useQueryClient()

	const mutation = useMutation({
		mutationFn: appointment.removeHomework,
    onSuccess: () => {
      queryClient.invalidateQueries(['appointment', appointmentId])
    },
  })

	return mutation
}